// removed by extract-text-webpack-plugin
module.exports = {"flex":"Flex__flex___dhbc9","isCenter":"Flex__isCenter___By8ie","reverse-m":"Flex__reverse-m___2T6LL","isStart":"Flex__isStart___3V_hz","move":"Flex__move___hLNyA","break-xs":"Flex__break-xs___1qkKd","break-m":"Flex__break-m___1ESqn","break-sm":"Flex__break-sm___2nyHR","break-l":"Flex__break-l___1Lhn1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Flex/Flex.scss
// module id = 539
// module chunks = 0